/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Rounding_AutoInputs */

const en_us2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic`)
};

const pt_br2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const es_419_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const pt_pt2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const fr_fr2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatique`)
};

const de_de2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch`)
};

const it_it2_workout_logging_rounding_auto = /** @type {(inputs: Workout_Logging_Rounding_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatico`)
};

/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Workout_Logging_Rounding_AutoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_rounding_auto = /** @type {((inputs?: Workout_Logging_Rounding_AutoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Rounding_AutoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_rounding_auto(inputs)
	if (locale === "es-419") return es_419_workout_logging_rounding_auto(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_rounding_auto(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_rounding_auto(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_rounding_auto(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_rounding_auto(inputs)
	return en_us2_workout_logging_rounding_auto(inputs)
});
export { workout_logging_rounding_auto as "workout-logging.rounding_auto" }